export const tilesMapping = {
  "Full page": [],

  "Front page": [
    "tradeName",
    "regulatoryAuthorisation",
    "regulatoryAuthorisation.authorisationNo",
    "regulatoryAuthorisation.authorisationNumber",
    "marketedBy",
    "summaryNotes",
    "productPackage",
    "safetyInformation",
    "safetyInformation.ufiNo",
    "safetyInformation.clinicalEmergencyPhoneNumber",
    "productActionType",
    "clinicalSupportOrganisation"
  ],

  "Formulation": [
    "tradeName",
    "formulationIngredients",
    "environmentalEmergencyOrganisation",
    "colour",
    "odour",
    "productActionType",
    "dangerousIngredientsWarning",
    "coformulantsQbaStatement",
    "materialState",
    "preparationType"
  ],

  "Authorisation": [
    "regulatoryAuthorisation",
    "regulatoryAuthorisationLabel",
    "manufacturer",
    "marketedBy",
    "otherMandatoryInformation",
    "technicalSupportOrganisation",
    "manufacturingLocation",
    "regulatoryAuthorisation.authorisationNoVersionHistory",
    "regulatoryAuthorisation.authorisationHolder",
    "regulatoryAuthorisation.regulator",
    "regulatoryAuthorisation.packagingContact",
    "regulatoryAuthorisation.labellingContact",
    "regulatoryAuthorisation.localRepresentative",
    "regulatoryAuthorisation.statutoryContext",
    "regulatoryAuthorisation.prohibitedUse",
    "regulatoryAuthorisation.permittedUse",
    "regulatoryAuthorisation.permittedUserCategories",
    "regulatoryAuthorisation.disclaimer"
  ],

  "Safety information": [
    "risks",
    "safetyInformation",
    "marketedBy",
    "productPackage",
    "safetyInformation.precautions",
    "risks.hazardStatements",
    "risks.signalWord",
    "risks.hazardClassifications",
    "safetyInformation.clinicalEmergencyPhoneNumber"
  ],

  "Additional safety precautions": [
    "safetyInformation",
    "safetyInformation.precautions",
    "additionalSafetyPrecautions",
    "safetyInformation.safetyDatasheetLink",
    "safetyInformation.precautions",
    "safetyInformation.clinicalEmergencyPhoneNumber",
    "safetyInformation.firstAidMeasures",
    "safetyInformation.firstAidMeasures",
    "safetyInformation.clinicalMeasures",
    "safetyInformation.clinicalSupportOrganisation",
    "safetyInformation.ppeInstructions",
    "safetyInformation.ppeInstructionsStructured",
    "safetyInformation.ppeDisposalInstructions",
    "safetyInformation.firefightingMeasures",
    "safetyInformation.environmentalEmergencyOrganisation",
    "safetyInformation.accidentalReleaseMeasures"
  ],

  "Directions for use": [
    "directionsForUse",
    "safetyInformation",
    "safetyInformation.precautions",
  ],

  "Restrictions": [
    "adverseEffects",
    "cropRotationGuidance",
    "cropFailureGuidance",
    "successionalCropGuidance"
  ],

  "Resistance information": [
    "modeOfActionDescription",
    "resistanceInformation",
    "ipmStatement",
    "formulationIngredients",
  ],

  "Transport, storage & disposal": [
    "directionsForStorage",
    "directionsForDisposal",
    "productPackage",
    "directionsForTransport",
    "storageTemperature"
  ],

  "Advisory information": [
    "additionalAdvisoryInformation"
  ]
};
